module.exports = __webpack_public_path__ + "labioplastika_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_4_before.jpg
// module id = 1074
// module chunks = 0